import { z } from 'zod';
import { defineEndpoint } from '../define';
import { JobSchema, RunnerStatusSchema } from './shapes';

export const QueuedJobSchema = JobSchema.extend({
  waitSeconds: z.number().int().nullable(),
  /**
   * Runners of the same repo whose labels cover the job's — candidates only.
   * Which one runs it is GitHub's call; the queue never names a machine.
   */
  eligibleRunners: z.array(
    z.object({ name: z.string(), status: RunnerStatusSchema, machineName: z.string().nullable() }),
  ),
});
export type QueuedJob = z.infer<typeof QueuedJobSchema>;

/** Jobs not yet running (queued / waiting), oldest first. */
export const listRunnerQueue = defineEndpoint({
  method: 'GET',
  path: '/v1/runner-monitor/queue',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.array(QueuedJobSchema) }),
});
